// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cBDg","bigColWidth":"Table_bigColWidth__3jZgD","biggerColWidth":"Table_biggerColWidth__2rk3G","row":"Table_row__W3He0","col":"Table_col__BjNfu"};